(function() {
  'use strict';

  function syncInert(el) {
    if (el.classList.contains('is-expanded')) {
      el.removeAttribute('inert');
    } else {
      el.setAttribute('inert', '');
    }
  }

  function setupAccordionObserver(el) {
    if (el.__inertFS) return;
    el.__inertFS = true;
    syncInert(el);
    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          syncInert(m.target);
        }
      });
    });
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function scanAll() {
    document.querySelectorAll('height-css-variable.content').forEach(setupAccordionObserver);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('height-css-variable.content')) {
              setupAccordionObserver(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('height-css-variable.content').forEach(setupAccordionObserver);
            }
          }
        });
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ---- filter panel inert management ---- */
  var FILTERS_PANEL_ID = 'collection-filters';

  function syncPanelInert() {
    var panel = document.getElementById(FILTERS_PANEL_ID);
    if (!panel) return;
    if (panel.classList.contains('is-active')) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }
  }

  function observeFiltersPanel() {
    var panel = document.getElementById(FILTERS_PANEL_ID);
    if (!panel) return;
    syncPanelInert();
    var obs = new MutationObserver(function() {
      syncPanelInert();
    });
    obs.observe(panel, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  if (document.readyState === 'complete') {
    observeFiltersPanel();
  } else {
    document.addEventListener('readystatechange', function() {
      if (document.readyState === 'complete') observeFiltersPanel();
    });
  }
})();
